// No seu arquivo de service
export class PostalCodeOfBrazilService {
  async getAddressByCep(cep: string) {
    const cleanCep = cep.replace(/\D/g, "");

    if (cleanCep.length !== 8) return null;

    const response = await fetch(
      `${process.env.REACT_APP_URL_VIA_CEP}/${cleanCep}/json/`,
    );

    if (!response.ok) throw new Error("Erro ao buscar CEP");

    const data = await response.json();

    if (data.erro) return null;

    return {
      street: `${data.logradouro}${data.bairro ? `, ${data.bairro}` : ""}`,
      city: data.localidade,
      state: data.uf,
    };
  }
}

export const postalCodeOfBrazilService = new PostalCodeOfBrazilService();
